/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name ArrowBottomLeft
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik01LjUzIDguMjI5YS43NS43NSAwIDExMS41IDB2Ny42ODlsOS45ODgtOS45ODhhLjc1Ljc1IDAgMDExLjA2IDEuMDZsLTkuOTg3IDkuOTloNy42OWEuNzUuNzUgMCAwMTAgMS41SDUuNTN6Ii8+PC9zdmc+) - https://fondue-components.frontify.com/?path=/story/icons-icons--default&args=iconName:arrow-bottom-left
 * @see https://fondue-components.frontify.com/?path=/story/icons-icons--default - Documentation
 */
export const IconArrowBottomLeft = createFondueIcon('ArrowBottomLeft', [["path",{"fill":"currentColor","d":"M5.53 8.229a.75.75 0 111.5 0v7.689l9.988-9.988a.75.75 0 011.06 1.06l-9.987 9.99h7.69a.75.75 0 010 1.5H5.53z"}]]);
